import React, { Component, Fragment } from "react";
import './Footer.css'
import { getCustomerConfig } from "../../../helpers";

export default class Footer extends Component {
  
  render() {
    const customConfig = getCustomerConfig();

    return (
      <Fragment>
        <div className={'FooterSpacer'}/>
        <p className={'Footer'}>
          <customConfig.FooterContent />
        </p>
      </Fragment>
    )
  }
}
